<ng-container
  [ngSwitch]="documentCalculationResult.payments.deposit?.isUnpaid()"
>
  <div *ngSwitchCase="true" class="deposit-request-action-wrapper">
    <div
      class="deposit-request-info"
      [ngClass]="{ 'is-invalid': invalidDeposit }"
    >
      <div class="deposit-request-label-wrapper">
        <app-icon *ngIf="invalidDeposit" class="error-icon" [icon]="errorIcon">
        </app-icon>

        <span class="deposit-request-label">
          {{ depositRequestLabel }}
        </span>
      </div>

      <span class="deposit-request-amount">
        {{
          documentCalculationResult.payments.deposit.totalAmount
            | money: documentSettings?.currencyCode:documentSettings?.locale
        }}
      </span>
    </div>

    <button
      type="button"
      class="action deposit-request-action"
      trackable
      [trackingObject]="documentTrackingObject"
      [trackingAction]="editDepositRequestTrackingAction"
      [trackingAdditionalProperties]="
        depositRequestTrackingAdditionalProperties
      "
      (click)="openDepositRequestDialog()"
    >
      {{ 'ACTION.VIEW_DEPOSIT_REQUEST' | translate }}
    </button>
  </div>

  <ng-container *ngSwitchDefault [ngSwitch]="!!deposit && enablePaidState">
    <div *ngSwitchCase="true" class="paid-state">
      <span>
        {{ 'LABEL.DEPOSIT_PAID' | translate }}
      </span>

      <div class="paid-amount">
        <span class="deposit-request-amount">
          {{
            documentCalculationResult.payments.deposit?.amountPaid
              | money: documentSettings?.currencyCode:documentSettings?.locale
          }}
        </span>

        <app-checkmark class="checkmark"></app-checkmark>
      </div>
    </div>

    <button
      *ngSwitchDefault
      type="button"
      class="action deposit-request-action"
      trackable
      [trackingObject]="documentTrackingObject"
      [trackingAction]="addDepositRequestTrackingAction"
      [trackingAdditionalProperties]="
        depositRequestTrackingAdditionalProperties
      "
      (click)="openDepositRequestDialog()"
    >
      {{ 'ACTION.ADD_DEPOSIT_REQUEST' | translate }}
    </button>
  </ng-container>
</ng-container>

<app-deposit-request-dialog
  [deposit]="
    documentCalculationResult?.payments.deposit?.isUnpaid() ? deposit : null
  "
  [depositRequestFeatureName]="depositRequestFeatureName"
  [addDepositForFuture]="addDepositForFuture"
  [featureToggles]="featureToggles"
  [account]="account"
  [documentAllAccess]="documentAllAccess"
  [documentType]="documentType"
  [documentDueDate]="documentDueDate"
  [documentCurrencyCode]="documentSettings?.currencyCode"
  [documentLocale]="documentSettings?.locale"
  [documentCalculationResult]="documentCalculationResult"
  [documentTrackingObject]="documentTrackingObject"
  [documentTrackingScreenName]="trackingScreenName"
  [trackingDialogName]="depositRequestTrackingDialogName"
  (onSaveRequest)="saveDepositRequest($event)"
  (onCancelRequest)="removeDepositRequest()"
  (onUpdateDepositToggleSettings)="updateDepositToggleSettings($event)"
>
</app-deposit-request-dialog>

<app-remove-deposit-request-dialog
  [trackingScreenName]="trackingScreenName"
  [documentType]="documentType"
  (onRemoveDepositRequest)="removeDepositRequest()"
>
</app-remove-deposit-request-dialog>

<ng-container *ngIf="documentType === DocumentTypesEnum.estimate">
  <app-confirm-dialog
    [dialogId]="newDepositDisabledDialogId"
    [confirmTitle]="'DIALOG.NEW_DEPOSIT_DISABLED.TITLE' | translate"
    [confirmPrompt]="'DIALOG.NEW_DEPOSIT_DISABLED.PROMPT' | translate"
    [cancelText]="'ACTION.NOT_NOW' | translate"
    [yesText]="'ACTION.GO_TO_INVOICE' | translate"
    [trackingDialogName]="depositDisabledTrackingDialogName"
    (onClose)="onDepositDisabledDialogClose.emit($event)"
  >
  </app-confirm-dialog>

  <app-confirm-dialog
    [dialogId]="existingDepositDisabledDialogId"
    [confirmTitle]="'DIALOG.EXISTING_DEPOSIT_DISABLED.TITLE' | translate"
    [confirmPrompt]="'DIALOG.EXISTING_DEPOSIT_DISABLED.PROMPT' | translate"
    [cancelText]="'ACTION.NOT_NOW' | translate"
    [yesText]="'ACTION.GO_TO_INVOICE' | translate"
    [trackingDialogName]="depositDisabledTrackingDialogName"
    (onClose)="onDepositDisabledDialogClose.emit($event)"
  >
  </app-confirm-dialog>
</ng-container>
